import React from 'react';
import { connect } from 'react-redux';

const EntityDashboard = () => <></>;

export default connect()(EntityDashboard);
